export default "__VITE_ASSET__BFeDJOKp__"